// extracted by mini-css-extract-plugin
export default {"wrapper":"AccordionBtn_wrapper__DNfFQ","accordion":"AccordionBtn_accordion__gtpmQ","icon":"AccordionBtn_icon__YdawD","panel":"AccordionBtn_panel__X62G1"};